import { useQuery } from 'react-query';
import { SrxApi } from '../api/SrxApi';

export const getAppAlertsItems = (responseData) => {
    if (Array.isArray(responseData)) return responseData;
    if (Array.isArray(responseData?.items)) return responseData.items;
    if (Array.isArray(responseData?.alerts)) return responseData.alerts;
    if (Array.isArray(responseData?.appAlerts)) return responseData.appAlerts;
    if (Array.isArray(responseData?.data)) return responseData.data;
    return [];
};

export const getAppAlertsCount = (responseData) => {
    const explicitCount =
        responseData?.totalCount ??
        responseData?.count ??
        responseData?.alertCount ??
        responseData?.appAlertCount;

    if (typeof explicitCount === 'number') return explicitCount;

    const parsedCount = Number(explicitCount);
    if (!Number.isNaN(parsedCount)) return parsedCount;

    return getAppAlertsItems(responseData).length;
};

const useGetAppAlerts = () => {
    const getAppAlerts = async () => {
        const response = await SrxApi.get('/GetAppAlerts');
        return response?.data ?? [];
    };

    const {
        data: appAlerts = [],
        isFetching: isAppAlertsLoading,
        isError: isAppAlertsError,
        refetch: refetchAppAlerts,
    } = useQuery(['getAppAlerts'], getAppAlerts, {
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: true,
        keepPreviousData: true,
    });

    return {
        appAlerts,
        appAlertItems: getAppAlertsItems(appAlerts),
        appAlertCount: getAppAlertsCount(appAlerts),
        isAppAlertsLoading,
        isAppAlertsError,
        refetchAppAlerts,
    };
};

export default useGetAppAlerts;
